import { useEffect, useRef } from "react";
import Prism from "prismjs";

const PrismCode = ({ code }) => {
  const ref = useRef(null);

  const highlight = () => {
    if (ref && ref.current) {
      Prism.highlightElement(ref.current);
    }
  };

  useEffect(() => {
    highlight();
  }, []);

  return (
    <pre className="line-numbers">
      <code ref={ref} className="language-js">
        {code.trim()}
      </code>
    </pre>
  );
};

export default PrismCode;
